
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";

import orosz from "../../assets/orosz.png"
import magyar from "../../assets/magyar.png"
import arrow from "../../assets/arrow.png"

function MagyarOrosz({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Magyar orosz fordító</title>
                <meta name='description' content="Ingyenes magyar orosz fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Magyar orosz fordító" />
                <link rel="canonical" href="https://online-fordito.hu/magyar-orosz-fordito" />
            </Helmet>
            <h1>Magyar orosz fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>


                <div className="sectionhead">
                    <h2>A magyar és orosz nyelv </h2>
                    <img src={magyar} alt="magyar zászló"></img>
                    <img src={orosz} alt="orosz zászló"></img>
                </div>


                <p>Az orosz az indoeurópai nyelvcsaládba, a szláv nyelvek csoportjába, míg a magyar az ugor-altaikus nyelvcsaládba tartozik.</p>

                <h3>Hasonlóságok</h3>
                <ul>
                    <li><b>Hangrendszerek</b>: Mind az orosz, mind a magyar nyelv rendelkezik hangrendszerekkel. Mindkét nyelvben megkülönböztetjük a magas és mély hangrendeket.</li>

                    <li><b>Ragozás</b>: Az orosz és a magyar nyelv gazdag ragozású nyelvek. Mindkét nyelvben a szavaknak többféle alakja van a különböző esetekben, számokban vagy névmódokban.</li>

                    <li><b>Szórend</b>: Általában mind az orosz, mind a magyar nyelvben az alany-állítmány-tárgy (AAT) szórend a leggyakoribb, bár mindkét nyelvben lehetnek eltérések és kivételek.</li>

                    <li><b>Szókincs</b>: Bár az orosz és a magyar nyelvnek eltérő szókincse van, vannak közös szavak és kifejezések is, amelyek azonos vagy hasonló jelentéssel rendelkeznek, különösen azon a területen, ahol a két nyelv történelmileg közel került egymáshoz.</li>
                </ul>
                <h3>Különbségek</h3>

                <ul>
                    <li><b>Nyelvcsalád és rokonság</b>: Az orosz indoeurópai nyelvcsaládba tartozik, míg a magyar ugor-altaikus nyelvcsaládba. Ez azt jelenti, hogy a két nyelvnek eltérő eredete és nyelvtörténete van.</li>

                    <li><b>Hangzások és kiejtés</b>: Az orosz és a magyar nyelvnek eltérő hangzásai és fonetikai rendszerei vannak. Az orosz nyelvben például több hangzó és ejtési variáció található, amelyek a magyarban nem léteznek, és fordítva.</li>

                    <li><b>Nyelvtani struktúra</b>: Az orosz és a magyar nyelv nyelvtani struktúrája is eltérő. Az orosz nyelvben más jelzőragok, névmások és igék használata lehet, mint a magyar nyelvben.</li>

                    <li><b>Írásrendszer</b>: Az orosz nyelv cirill betűs írásrendszert használ, míg a magyar nyelv latin betűket alkalmaz.</li>
                </ul>

                <div className="sectionbottom">
                    <Link to="/orosz-magyar-fordito">Orosz magyar fordító</Link>
                    <img src={orosz} alt="orosz zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>
                </div>
            </section>
        </>

    )
}

export default MagyarOrosz;